function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.48784 3.84944L6.75701 3.43348L5.53645 0.847861C5.31776 0.38698 4.68411 0.381122 4.46355 0.847861L3.24299 3.43348L0.512157 3.84944C0.0224387 3.92365 -0.173823 4.55443 0.181317 4.91572L2.15701 6.92719L1.68973 9.76863C1.60561 10.2822 2.12337 10.667 2.55701 10.4268L5 9.08512L7.44299 10.4268C7.87663 10.665 8.39439 10.2822 8.31028 9.76863L7.84299 6.92719L9.81868 4.91572C10.1738 4.55443 9.97756 3.92365 9.48784 3.84944Z",
  fill: ""
});

var SvgIcStar = function SvgIcStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_star.9d2cfb94.svg";
export { ForwardRef as ReactComponent };